'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'paper-plane-top';
var width = 512;
var height = 512;
var aliases = ["paper-plane-alt","send"];
var unicode = 'e20a';
var svgPathData = 'M110 248L24.3 48l36 0 400 200L110 248zm350.2 16L60.2 464l-36 0L110 264l350.2 0zM0 32L6.9 48 96 256 6.9 464 0 480l17.4 0L64 480 494.1 264.9 512 256l-17.9-8.9L64 32 17.4 32 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPaperPlaneTop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;